import firebaseDB from '@src/firebase/database';
import { selectCurrentProfile, selectRewards } from '@src/store/selectors';
import { RewardsTypes as types, RewardsActions as actions } from '../reducers/Rewards';


const logger = Logger.get( 'firebase/listeners' );

const transformData = ( key ) => ( callback ) => ( listMap = {} ) => {

    let list = []
    for( let prop in listMap ){
        let data = listMap[ prop ];
        if( !( data instanceof Object ) )continue;
        data[ key ] = prop ;
        list.push( data );
    } 
    return callback ( list ) ;
}

const attachListener = ( basepath = null, getAction ) => ( currentpath = '', dispatch , rewards) =>{
 
    if( currentpath === basepath  && rewards?.rewards ) return ;
    logger.log( currentpath, basepath );
    if( basepath ) firebaseDB.getSubscriberPath().ref( basepath ).off( 'value' ) ;

    firebaseDB.getSubscriberPath().ref( currentpath ).on( 'value', ( data ) =>  dispatch( getAction( data ) ) );

    basepath = currentpath ;
}

const onBadges = transformData( 'badgeId' )( actions.SetBadges );
const onCertificates = transformData( 'certificateId' )( actions.SetCertificates );
const onAvatars = transformData( 'avatarid' )( actions.SetAvatars );

const listenRewards = attachListener( null, actions.SetRewards );
const listenBadges = attachListener( null, onBadges );
const listenCertificates = attachListener( null, onCertificates );
const listenAvatars = attachListener( null, onAvatars );

const FirebaseListeners = (store, action) => {

    if( action.type !== types.SetListeners )return null ;

        const profile = selectCurrentProfile( store.getState() );
        const rewards = selectRewards(store.getState());
       
        const rewardsPath = `/${ profile.profileid }/rewards/total`;
        const badgePath = `/${ profile.profileid }/levels/${ profile.currentLevel }/badges`;
        const certificatesPath = `/${ profile.profileid }/levels/${ profile.currentLevel }/certificates`;
        const avatarsPath = `/${ profile.profileid }/avatar`;

        listenRewards( rewardsPath, store.dispatch , rewards);
        listenBadges( badgePath, store.dispatch , rewards);
        listenCertificates(certificatesPath, store.dispatch, rewards );
        listenAvatars( avatarsPath, store.dispatch , rewards);
  };


export default FirebaseListeners ;